/** Stable DOM ids for Org Activity card CTAs (scroll + focus). */
export const ADS_MANUAL_FORM_ID = "ads-manual-ingest-form";
export const ADS_INDEXED_ANCHOR_ID = "ads-activity-indexed-posts";
